import { useTranslation } from 'react-i18next';
import React, {useState, useEffect,Fragment,useRef} from 'react';
import {Typography,Button,TableContainer,Table,TableRow,TableCell,TableBody,Box,Grid, TextField,Paper, MenuItem} from "@mui/material";
import ResponsiveDialog from '../shared/components/ResponsiveDialog'
import apiRequest from '../../functions/api';
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import { useMessage } from '../../context/message-context';
import DynamicTable from "../shared/components/DynamicTableComponent";
import Page from "../shared/components/PageComponent";
import { FullPageSpinner } from "../lib";
import MessageBox from "../shared/components/MessageBox";
function HRTurnus(props) {
  const { t } = useTranslation();
const { accessToken,  client,} = props;
const [auswahl,setAuswahl]=useState("");
const [isLoading, setIsLoading] = useState(false);
const [stamm,setStamm] = useState([]);
const[filter,setFilter]=useState("");
const[suche, setze_suche]=useState("");
const [options,setOptions] = useState([]);
const zeilenauswahl=useRef("");
const fehlertext=useRef("");
const spaltenauswahl=useRef("");
const [aenderung,setAenderung]=useState("");
const [anlagename,setAnlageName] = useState("");
const [spin,setSpin]=useState(false)
const {hideMessage, showErrorMessage,showSuccessMessage} = useMessage();
const [messageopen,setMessageOpen]=useState("")
useEffect(() => {
  init()
  // eslint-disable-next-line
}, [])
const errorcB = () => {
  setIsLoading(false);
  setSpin(false);
  showErrorMessage(t("Keine Internetverbindung. Bitte erneut versuchen"));
}
const InitCb = (response) => {
  setIsLoading(false);
  if (response.status === 200) {
      if (response.data.stamm) {
        setStamm(response.data.stamm)   
      }
      if (response.data.stamm?.menufilterinit) {
          setFilter(response.data.stamm.menufilterinit)
      }
      if (response.data.options) {
        setOptions(response.data.options)
      }    
      hideMessage();
  } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
  }      
}
const init = () => {
  setIsLoading(true);
  const payload={
    "mandant": client,
    "program": "HRTURN",
    "statement": "INIT",
  }
  const headers={
    "Authorization": "Bearer "+accessToken,
  }
  apiRequest('POST', 'daten', payload, headers, InitCb);
}
const zeichne_neuanlage = () => {
  if (stamm) {
    if (stamm?.neuanlage) {
      return(
        <Fragment>
        <Grid item xs={3}>
          <Button variant="contained" fullWidth color="primary"  onClick={()=> buttonClick("NEUANLAGE","",)} > {stamm?.anlagetext ? stamm?.anlagetext: "Neuanlage" }  </Button>
        </Grid>
        <Grid item xs={6}>
          <Fragment></Fragment>
        </Grid>
        <Grid item xs={3}>
          <Fragment>
            { (auswahl!=="" && aenderung!=="" && auswahl!=="NEU") &&
              <Button variant="contained" fullWidth color="primary"  onClick={()=> buttonClick("SPEICHERN",auswahl,)} >{t(" Speichern ")}</Button>
            }
            { (auswahl==="NEU") &&
              <Button variant="contained" fullWidth color="primary"  onClick={()=> buttonClick("SPEICHERN",auswahl,)} >{t(" Speichern ")}</Button>
            }
          </Fragment>
        </Grid>
        </Fragment>
      )
    }
  }
}
const anfrageCB = (response) => {
   setIsLoading(false);
   setSpin(false);
   if (response.status === 200) {
      if (response.data.message) {
        setAenderung("");
        setAnlageName("");
        if (auswahl==="NEU") {
          setAuswahl(false);
        }
        if (response.data.message!=="ok") {
          showSuccessMessage(response.data.message)
        }
      }
      if (response.data.stamm) {
        setStamm(response.data.stamm)
      }
      if (response.data.options) {
        setOptions(response.data.options)
      }
      if (response.data.auswertung) {
        setAuswertung(response.data.auswertung)
        setShowAuswertung(true)
      }
   } else {
       if (response) {
        fehlertext.current=response.data?.message;
        setMessageOpen(true)
        if (response.data.stamm) {
          setAnlageName("");
          setAenderung("");
          setStamm(response.data.stamm)
        }
     //    showErrorMessage(response.data.message);
       } else {
         showErrorMessage(t("Keine Internetverbindung"));
       }
   }      
 }
 const buttonAnfrage = (statement,button,key) => {
   setIsLoading(true);
   const payload={
     "mandant": client,
     "program": "HRTURN",
     "statement": statement,
     "button": button,
     "key":key,
   }
   const headers={
     "Authorization": "Bearer "+accessToken,
   }
   apiRequest('POST', 'daten', payload, headers, anfrageCB, errorcB);
 }
const speichern = () => {
  setSpin(true);
  const payload={
    "mandant": client,
    "program": "HRTURN",
    "statement": "SPEICHERN",
    "key":zeilenauswahl.current,
    "name":anlagename,
    "monate":stamm.tabelle[auswahl+"MONATE"],
    "tage":stamm.tabelle[auswahl+"TAGE"],
    "arbeitstage":stamm.tabelle[auswahl+"ARBEITSTAGE"],
    "feiertag":stamm[auswahl]["feiertags"],
    "fristart":stamm[auswahl]["fristart"],
    "fristwert":stamm[auswahl]["fristwert"],
  }
  const headers={
    "Authorization": "Bearer "+accessToken,
  }
  apiRequest('POST', 'daten', payload, headers, anfrageCB, errorcB);
}
const buttonClick = (spaltenkey,zeilenkey,zaehler,gridart) => {
   switch (spaltenkey) {
      case "ABWÄHLEN":
        if (zeilenkey==="MONATE") {
          for ( let i=0; i<12; i++ ) {
            stamm.tabelle[auswahl+zeilenkey][i]["AUSWAHL"]="0"
          }
          setAenderung(zeilenkey+"ALLE0")
        }
        if (zeilenkey==="TAGE") {
          for ( let i=0; i<31; i++ ) {
            stamm.tabelle[auswahl+zeilenkey][i]["AUSWAHL"]="0"
          }
          setAenderung(zeilenkey+"ALLE0")
        }
        if (zeilenkey==="ARBEITSTAGE") {
          for ( let i=0; i<7; i++ ) {
            stamm.tabelle[auswahl+zeilenkey][i]["AUSWAHL"]="0"
          }
          setAenderung(zeilenkey+"ALLE0")
        }
       break;
      case "SPEICHERN":
        zeilenauswahl.current=zeilenkey
        spaltenauswahl.current=spaltenkey
        speichern()
       break;
      case "AUSWÄHLEN":
        if (zeilenkey==="MONATE") {
          for ( let i=0; i<12; i++ ) {
            stamm.tabelle[auswahl+zeilenkey][i]["AUSWAHL"]="1"
          }
          setAenderung(zeilenkey+"ALLE1")
        }
        if (zeilenkey==="TAGE") {
          for ( let i=0; i<31; i++ ) {
            stamm.tabelle[auswahl+zeilenkey][i]["AUSWAHL"]="1"
          }
          setAenderung(zeilenkey+"ALLE1")
        }
        if (zeilenkey==="ARBEITSTAGE") {
          for ( let i=0; i<7; i++ ) {
            stamm.tabelle[auswahl+zeilenkey][i]["AUSWAHL"]="1"
          }
          setAenderung(zeilenkey+"ALLE1")
        }
       break;
      case "MENUAUSWAHL":
        setAuswahl(zeilenkey)
        setAenderung("")
       break;
      case "NEUANLAGE":
        setAuswahl("NEU")
        setAenderung("")
       break;
      case "AUSWAHL":
        if  (stamm.tabelle[auswahl+gridart][zaehler][spaltenkey]) {
          if (stamm.tabelle[auswahl+gridart][zaehler][spaltenkey]==="1"){stamm.tabelle[auswahl+gridart][zaehler][spaltenkey]="0";setAenderung(auswahl+gridart+zaehler+"0");return}
          if (stamm.tabelle[auswahl+gridart][zaehler][spaltenkey]==="0"){stamm.tabelle[auswahl+gridart][zaehler][spaltenkey]="1";setAenderung(auswahl+gridart+zaehler+"1");return}
        } 
       break;
      case "FRISTART":
        if (auswahl && auswahl!=="NEU") {return}
        setAenderung(zeilenkey+"FRISTART")
        if (stamm?.[auswahl]?.["fristart"]) {stamm[auswahl]["fristart"]=zeilenkey}
       break;
       case "TURNWERT":
        setAenderung(zeilenkey+"TURNWERT")
        stamm[auswahl]["fristwert"]=zeilenkey
       break;
       default:
         zeilenauswahl.current=zeilenkey
         spaltenauswahl.current=spaltenkey  
         buttonAnfrage("BUTTON_START",spaltenkey,zeilenkey) 
       break;
   }
}
const fitlerByType = (element) => {
  var result;
  result=true
  if (filter!=="") {
    if (filter!==element.filter) {result=false} 
  }
  if (!element.bez.toLowerCase().includes(suche.toLowerCase())) {result=false}
  return(result);
}
if (isLoading) {
  return (
      <LoadingComponent />
  )
}
const zeichne_links = () => {
  if (stamm?.menu?.filter(element => fitlerByType(element)).length>0) {
    return(
      stamm?.menu.filter(element => fitlerByType(element)).map ((element)=> {
          return(
            <TableRow>
              <TableCell>
                <Button fullWidth color={element.key===auswahl ? "primary" : ""} onClick={()=>  buttonClick("MENUAUSWAHL",element.key,)} style={{justifyContent:"flex-start",}}>{element.bez}</Button>
              </TableCell>
            </TableRow>
          )  
      })
      )
  } else {
      return (
          <Typography>{t("keine Menupunkte vorhanden")}</Typography>
      )        
  }
}
const aenderefeiertag = (wert) => {
  stamm[auswahl]["feiertags"]=wert
  setAenderung(auswahl+"FEIERTAGS"+wert)
}
const zeichne_filter = () => {
  if (stamm) {
  if (stamm?.menufilter?.length>0 || stamm?.auswertung || stamm?.wechseln) {
     return (
      <Fragment>
      <Grid item xs={3}>
          <Box p={1}>
          { stamm?.menufilter?.length>0 &&
              <TextField
                  select
                  variant="outlined"
                  label={t("Filter")}
                  value={filter}
                  onChange={(event) => setze_filter(event.target.value)}
                  fullWidth
                  InputLabelProps={{
                      shrink: true,
                  }}
              >
                  {  stamm?.menufilter?.map((filters)=> {
                          return (
                              <MenuItem value={filters.key}>{filters.bez}</MenuItem>
                          )
                      }) 
                  } 
              </TextField>
            }
          </Box>
      </Grid>
      <Grid item xs={10}>
        <Box p={1}>
          { stamm?.wechseln &&
              <Button fullWidth variant="outlined" color="primary" onClick={()=> buttonClick("WECHSELN",stamm?.wechseln,)} >{stamm?.wechseln_text}</Button>
          }
        </Box>
      </Grid>
      </Fragment>
     )
  }
  }
}
const handleResponse = (result) => {
  setMessageOpen(false);
  fehlertext.current=""
}
const zeichne_tabellen = () => {
  var turnusart=""
  var turnuswert=""
  turnusart=stamm?.[auswahl]?.fristart
  turnuswert=stamm?.[auswahl]?.fristwert
  return (
    <Fragment>
    <Grid item xs={4} >
    <Paper style={{ height:1000, width:"100%"}}>
    <Box p={1}>
      <Typography color="primary">{t("Gültigkeit des Turnus in")}</Typography>
    </Box>  
    
    {  auswahl && 
    <Box p={1}>
      <TextField 
        variant="outlined"
        select
        value={turnusart}
        onChange={(event) => buttonClick("FRISTART",event.target.value)}
        fullWidth
        disabled={auswahl && auswahl!=="NEU"}
        InputLabelProps={{
          shrink: true,
        }}
      >
        <MenuItem value={"F"}>{t("feste Gültigkeit")}</MenuItem>
        <MenuItem value={"T"}>{t("Tage")}</MenuItem>
        <MenuItem value={"M"}>{t("Monate")}</MenuItem>
        <MenuItem value={"J"}>{t("Jahre")}</MenuItem>
      </TextField>
      </Box> 
    }
    
    <Box p={1}>
      <Typography color="primary"> {turnusart==="F" ? "An welchem Monat?" :""} </Typography>
    </Box>
    <Box p={1}>
      {  auswahl && turnusart==="F" &&
      <Fragment>
        <Button variant="outlined" onClick={()=> buttonClick("AUSWÄHLEN","MONATE",)}>{t(" Alle Auswählen ")}</Button>
        <Button variant="outlined" onClick={()=> buttonClick("ABWÄHLEN","MONATE",)}>{t(" Alle Abwählen")}</Button> 
      </Fragment>
      }           
      <DynamicTable zeilen={ turnusart==="F" ? stamm?.tabelle?.[auswahl+"MONATE"]:""} spalten={stamm?.tabelle?.ueber} options={options} leertext={" "} hoehe={800} buttonCb={(spaltenkey,zeilenkey,zaehler) => buttonClick(spaltenkey,zeilenkey,zaehler,"MONATE")} minbreite={300}  size={"small"} ladevariable={auswahl}/>   
    </Box>
   </Paper>
   </Grid>
   <Grid item xs={4} >
    <Paper style={{ height:1000, width:"100%"}}>
    <Box p={1}>
      <Typography color="primary">{turnusart==="F" ? "An welchem Kalendertag?" :"Wert der Gültigkeit"}</Typography>
    </Box>
    <Box p={1}>
      { auswahl && turnusart==="F" &&
      <Fragment>
        <Button variant="outlined" onClick={()=> buttonClick("AUSWÄHLEN","TAGE",)}>{t(" Alle Auswählen ")}</Button>
        <Button variant="outlined" onClick={()=> buttonClick("ABWÄHLEN","TAGE",)}>{t(" Alle Abwählen")}</Button>
      </Fragment>
      }
      { auswahl && turnusart!=="F" &&
      <Fragment>
        <TextField type="number" variant="outlined" value={turnuswert} onChange={(event) => buttonClick("TURNWERT",event.target.value)} ></TextField>
      </Fragment>     
      }
      <DynamicTable zeilen={ turnusart==="F" ? stamm?.tabelle?.[auswahl+"TAGE"]: ""} spalten={stamm?.tabelle?.ueber} options={options} leertext={" "} hoehe={800} buttonCb={(spaltenkey,zeilenkey,zaehler) => buttonClick(spaltenkey,zeilenkey,zaehler,"TAGE")} minbreite={300}  size={"small"} ladevariable={auswahl}/>        
    </Box>
   </Paper>
   </Grid>
   <Grid item xs={4} >
    <Paper style={{ height:1000, width:"100%"}}>
    
    <Box p={1}>
      <Typography color="primary">{turnusart==="F" ? "Auch an Feiertagen?" :""} </Typography>
    </Box>  
    { auswahl && turnusart==="F" && 
    <Box p={1}>
      <TextField fullWidth variant="outlined" select 
        onChange={(e) => aenderefeiertag(e.target.value)}
        value={stamm?.[auswahl]?.feiertags}
        variant="outlined"
        InputLabelProps={{
          shrink: true,
        }}
        >
          <MenuItem value={"0"}>{"Nein"}</MenuItem>
          <MenuItem value={"1"}>{"Ja"}</MenuItem>
        </TextField>
    </Box>  
    }
    <Box p={1}>
      <Typography color="primary">{turnusart==="F" ? "An welchem Wochentag?" :""}</Typography>
    </Box>  
    <Box p={1}>
    { auswahl && turnusart==="F" &&
      <Fragment>
      <Button variant="outlined" onClick={()=> buttonClick("AUSWÄHLEN","ARBEITSTAGE",)}>{t(" Alle Auswählen ")}</Button>
      <Button variant="outlined" onClick={()=> buttonClick("ABWÄHLEN","ARBEITSTAGE",)}>{t(" Alle Abwählen")}</Button>
      </Fragment>
    }
       <DynamicTable zeilen={turnusart==="F" ? stamm?.tabelle?.[auswahl+"ARBEITSTAGE"]: ""} spalten={stamm?.tabelle?.ueber} options={options} leertext={" "} hoehe={800} buttonCb={(spaltenkey,zeilenkey,zaehler) => buttonClick(spaltenkey,zeilenkey,zaehler,"ARBEITSTAGE")} minbreite={300}  size={"small"} ladevariable={auswahl}/>   
    </Box>
   </Paper>
   </Grid>
   </Fragment>
  )
}
return (
  <Page >
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={10}>
          <Grid container spacing={2} justifyContent="center">
          
          {zeichne_filter()}
          
            <Grid item xs={3}>
            <Paper style={{ height:1000, width:"100%"}}>
              <Box p={1}>
                <TextField 
                  variant="outlined"
                  label={t("Suche")}
                  value={suche}
                  onChange={(event) => setze_suche(event.target.value)}
                  fullWidth
                  InputLabelProps={{
                      shrink: true,
                  }}
                >
                </TextField>
                
                <TableContainer  style={{ height:900, width:"100%"}} >
                  <Table>
                    <TableBody>
                      {zeichne_links()}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Paper>
            </Grid>
          
            <Grid item xs={9}>
          
            <Grid item xs={12}>
            <Grid container justifyContent="center">  
              {  zeichne_tabellen()}
              </Grid> 
            </Grid>
            </Grid>
  
             {zeichne_neuanlage()}
           </Grid>
           
          </Grid>
        </Grid>
            
    { spin &&
      <FullPageSpinner/>
    }
    <MessageBox 
      open={messageopen}
      handleResponse={handleResponse}
      text={fehlertext.current}
      title={t("Hinweis")}
      onClose={() => handleResponse(false)}
    />
  </Page>
)
}
export default HRTurnus;
